<template>
  <div class="more" v-lazy>
    <Card class="shadow-2">
      <template slot="content"> <p>More is Coming...</p></template>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/common/Card";
export default {
  components: {
    Card,
  },
};
</script>

<style lang="less" scoped>
.more {
  width: 100%;
  .card {
    width: 1346px;
    background: #39bcf9!important;
    color: #fff;
    height: 400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
  }
}
</style>
